module.exports = ".fondo-gris {\n  background-color: #f2f2f2; }\n"